import React from 'react'
import Navbar from './Navbar';

function Header() {
  return (
    <>
      <div className='border-bottom'>
  <div className='container '>
    <div className='row py-3 align-items-center'>
      <div className='col-lg-6 d-flex align-items-center justify-content-lg-start justify-content-center'>
        <div className="dropdown d-flex">
        <button className="btn dropdown-toggle p-0 me-2 d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <img className='rounded-circle' height={20} width={20} src={require('../images/eng.png')}/>
    <p className='px-2'>English</p>
  </button>
  <ul className="dropdown-menu">
    <li><a className="dropdown-item d-flex align-items-center" href="/"><img className='rounded-circle' height={20} width={20} src={require('../images/eng.png')}/>
    <p className='p-2'>English</p></a></li>
    <li><a className="dropdown-item d-flex align-items-center" href="/"><img className='rounded-circle' height={20} width={20} src={require('../images/fn.png')}/>
    <p className='p-2'>France</p></a></li>
    <li><a className="dropdown-item d-flex align-items-center" href="/"><img className='rounded-circle' height={20} width={20} src={require('../images/us.png')}/>
    <p className='p-2'>United States</p></a></li>
  </ul>
  <button className="btn dropdown-toggle me-2 d-flex align-items-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <p className='pe-2'>USD</p>
  </button>
  <ul className="dropdown-menu">
    <li><a className="dropdown-item" href="/">USD</a></li>
    <li><a className="dropdown-item" href="/">EUR</a></li>
    <li><a className="dropdown-item" href="/">GBR</a></li>
  </ul>
  </div>
  <i className="bi bi-phone pe-2"></i>
  <p>123-456-7890</p>
  </div>
      <div className='col-lg-6'>
        <div className='d-flex float-lg-end justify-content-sm-center'>
          <div className='right d-flex'>
      <i className="bi bi-shuffle pe-2"></i>
      <p className='me-3'>Compare</p>
      </div>
      <div className='right d-flex'>
      <i className="bi bi-heart pe-2"></i>
        <p className='me-3'>Wishlist</p>
      </div>
      <div className='right d-flex'>
      <i className="bi bi-person pe-2"></i>
        <p className='me-3'>Login</p>
      </div>  
        </div>
      </div>
    </div>
  </div>
  </div>
  <Navbar/>
    </>
  )
}
export default Header
